import { useState } from "react";
import { api, ApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { BrandLogo } from "@/components/Logo";
import { Spinner } from "@/components/ui";
import { TextInput } from "@/components/fields";

export function ForcePasswordChange() {
  const { refresh, logout } = useAuth();
  const [f, setF] = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (f.newPassword !== f.confirm) { setErr("Passwords do not match"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/auth/change-password", { currentPassword: f.currentPassword, newPassword: f.newPassword });
      await refresh();
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : "Could not change password");
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <BrandLogo height={60} />
          <h2 className="mt-3 font-serif text-xl font-bold">Set a new password</h2>
          <p className="mt-1 text-sm text-ink-soft">Your account uses a temporary password. Choose your own to continue.</p>
        </div>
        <div className="card p-6">
          <form onSubmit={submit} className="space-y-3.5">
            {err && <div className="rounded-lg bg-st-delayed/10 px-3 py-2 text-sm text-st-delayed">{err}</div>}
            <label className="block">
              <span className="label">Current (temporary) password</span>
              <TextInput type="password" value={f.currentPassword} onChange={(e) => setF({ ...f, currentPassword: e.target.value })} required />
            </label>
            <label className="block">
              <span className="label">New password (min 10 chars)</span>
              <TextInput type="password" minLength={10} value={f.newPassword} onChange={(e) => setF({ ...f, newPassword: e.target.value })} required />
            </label>
            <label className="block">
              <span className="label">Confirm new password</span>
              <TextInput type="password" minLength={10} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required />
            </label>
            <button className="btn-primary w-full" disabled={busy}>{busy ? <Spinner /> : "Save and continue"}</button>
            <button type="button" className="w-full text-center text-xs text-ink-faint hover:text-brand-600" onClick={() => logout()}>Sign out</button>
          </form>
        </div>
      </div>
    </div>
  );
}
